import React, {useEffect} from 'react';
import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {Colors} from '../../constants/Colors';
import {useGlobalAlertStore} from '../../store/GlobalAlertStore';

const BG: Record<string, string> = {
  error: '#E8354A',
  success: Colors.GreenPallete.greenOne,
  info: '#444444',
};

const GlobalAlert = () => {
  const {visible, title, message, type, hide} = useGlobalAlertStore();

  useEffect(() => {
    if (!visible) {
      return;
    }
    const timeout = setTimeout(hide, 5000);
    return () => clearTimeout(timeout);
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <TouchableOpacity style={styles.container} onPress={hide} activeOpacity={0.9}>
      <View style={[styles.toast, {backgroundColor: BG[type] ?? BG.info}]}>
        <Text style={styles.title}>{title}</Text>
        {!!message && <Text style={styles.message}>{message}</Text>}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 12,
    left: 12,
    right: 12,
    zIndex: 9999,
    elevation: 20,
  },
  toast: {
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  title: {
    color: 'white',
    fontSize: 14,
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontWeight: '600',
  },
  message: {
    color: 'white',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    marginTop: 2,
    opacity: 0.9,
  },
});

export default GlobalAlert;
